import React from "react";
import RZScrollBar from "./../../fragments/RZScrollBar";
import Switch from "assets/ui_assets/controls/Switch";
import RZSkillMasterItem from "./../../fragments/RZSkillMasterItem";
import { AlexaCommon } from "utils/Common";
import { RazerSkillContext } from "razerskill-context";
import { ThemeContext, themes } from "theme-context";
import "css/RazerSkill.scss";

const autoBind = require("auto-bind");

class RazerSkill extends React.Component {
  _isMounted = false;

  constructor(props) {
    super(props);
    autoBind(this);
    this.avsWrapper = this.props.avsWrapper;

    this.state = {
      synapseStatus: false,
      shouldShowContent: false,
      dynamicScrollHeight: "450px",
    };
  }

  /**
   * @event window.rzevent.EventTypes.RESPONSE_SYNAPSE_DATA
   * @param {object} data
   */
  subscribeEvents() {
    window.rzevent.listenEvent(
      window.rzevent.EventTypes.RESPONSE_SYNAPSE_DATA,
      "2",
      (data = {}) => {
        this.onResponseSynapseData(data);
      }
    );
    //dynamic scrollbar
    window.addEventListener("resize", this.updateScrollViewerHeight.bind(this));
    this.setState(
      {
        shouldShowContent: true,
      },
      () => {
        AlexaCommon.consoleLogDataUIImportantInfo(
          "Now Razer skill page can show",
          this.state.shouldShowContent
        );
      }
    );
  }

  updateScrollViewerHeight = () => {
    let heightInPx = (window.innerHeight - 20).toString() + "px";
    if (!this._isMounted) {
      return;
    }
    this.setState({ dynamicScrollHeight: heightInPx });
  };

  /**
   * @description
   * when Razer Skill page get event
   * @function synapseStatus
   */
  onResponseSynapseData = (data) => {
    let alexaJsonObj = AlexaCommon.parseSynapseStringToJsonObj(data);
    //Get Razer skill toggle boolean.
    let alexaRazerSkillStatus = AlexaCommon.getSynapseRazerSkillStatus(
      alexaJsonObj
    );
    if (!this._isMounted) {
      return;
    }
    this.setState({ synapseStatus: alexaRazerSkillStatus });
  };

  /**
   * @emits window.rzevent.EventTypes.SYNAPSE_STATUS_CHANGE
   * @description
   * when synapse status switch is interacting with User
   */
  onSynapseStatusChange = () => {
    if (!this._isMounted) {
      return;
    }
    this.setState(
      {
        synapseStatus: !this.state.synapseStatus,
      },
      () => {
        window.rzevent.triggerEvent(
          window.rzevent.EventTypes.SYNAPSE_STATUS_CHANGE,
          this.state.synapseStatus
        );
        AlexaCommon.consoleLogDataUIImportantInfo(
          "SYNAPSE_STATUS_CHANGE event is called",
          this.state.synapseStatus
        );
      }
    );
  };

  /**
   *
   * @param {object} RazerSkillContextObj
   * @example
   * check razerSkill object in razerskill-context.js
   */
  createSkillPageFromSettings(RazerSkillContextObj) {
    return (
      <div className="title-content alexa-padding-top-10 alexa-padding-bottom-10 .alexa-margin-bottom-10">
        <div
          className="alexa-padding-top-10"
          style={{ display: "inline-flex" }}
        >
          <span className="main-title ">{RazerSkillContextObj.title}</span>
          <span
            className="alexa-border-box alexa-inline-block"
            style={{ marginLeft: "10px" }}
          >
            <Switch
              active={this.state.synapseStatus}
              onClick={this.onSynapseStatusChange}
            />
          </span>
        </div>
        <br />
        <span className="subtitle alexa-padding-top-10">
          {RazerSkillContextObj.subtitle}
        </span>
        <br />
        {RazerSkillContextObj.skills && (
          <>
            <ThemeContext.Consumer>
              {(values) =>
                RazerSkillContextObj.skills.map((skill, index) => (
                  <React.Fragment key={index}>
                    <div className="skill-header">
                      <h2>{skill.title}</h2>
                      <span
                        dangerouslySetInnerHTML={{ __html: skill.subtitle }}
                      />
                    </div>
                    {skill.content.map((item, itemIndex) => (
                      <RZSkillMasterItem
                        key={itemIndex}
                        iconSrc={
                          values === themes.dark
                            ? item.iconSrc
                            : item.iconSrcLight
                        }
                        title={item.title}
                        subTitle={item.subTitle}
                        expandText={item.expandText}
                        closeText={item.closeText}
                        list={item.list}
                      ></RZSkillMasterItem>
                    ))}
                  </React.Fragment>
                ))
              }
            </ThemeContext.Consumer>
          </>
        )}
      </div>
    );
  }

  //override
  componentDidMount() {
    //register listen first
    //init event
    this._isMounted = true;
    this.subscribeEvents();
    this.updateScrollViewerHeight();
    this.onResponseSynapseData(AlexaCommon.getalexa());
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  renderContentWrapper() {
    let contentWrapper = "";
    if (this.state.shouldShowContent) {
      let contents = this.createSkillPageFromSettings(this.context());
      contentWrapper = (
        <div className="skill-content-wrapper alexa-content-wrapper">
          {contents}
        </div>
      );
    }
    return contentWrapper;
  }

  render() {
    return (
      <div className="logged-in-container" style={{ marginRight: "2px" }}>
        <div
          style={{
            position: "relative",
            height: this.state.dynamicScrollHeight,
            width: "100%",
            overflowY: "scroll",
          }}
        >
          {this.renderContentWrapper()}
        </div>
      </div>
    );
  }
}
RazerSkill.contextType = RazerSkillContext;
export default RazerSkill;
